import { render } from "./SideMenuBreadcrumb.vue?vue&type=template&id=8c911e76&scoped=true"
import script from "./SideMenuBreadcrumb.vue?vue&type=script&lang=js"
export * from "./SideMenuBreadcrumb.vue?vue&type=script&lang=js"

import "./SideMenuBreadcrumb.vue?vue&type=style&index=0&id=8c911e76&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\xampp\\htdocs\\ui\\2025\\07\\tokyo-shoseki\\r9\\08k_sekta\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c911e76"]])

export default __exports__